export default function isOtherLocation(location) {
  return location === "Other";
}
